import styled from 'styled-components'
import { PairWith } from '@velasca/ui/pair-with'
import { SimpleRelatedSoles } from '@velasca/ui/simple-related-soles'

export const SwatchesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const ColorSelectorSliderWrapper = styled.div`
  max-width: 42.5rem;

  .variant-slider-wrapper {
    padding-left: 0;
    padding-right: 0;
  }

  @media screen and (min-width: 768px) {
    .variant-slider-wrapper {
      .swiper {
        width: 40rem;
      }
    }
  }
`

export const InfoBlock = styled.div<{ $isGiftCard?: boolean }>`
  width: 100%;
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.background};
  gap: 2rem;
  display: flex;
  flex-direction: column;
  padding-bottom: ${({ $isGiftCard }) => ($isGiftCard ? '0' : '2rem')};

  @media screen and (min-width: 768px) {
    padding: 0;
    margin-top: -0.7rem;
    padding-bottom: ${({ $isGiftCard }) => ($isGiftCard ? '0' : '2rem')};
  }
`

export const Head = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 992px) {
    flex-direction: column-reverse;
  }
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 1.5rem 0 1rem 0;
  gap: 1rem;
`

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`

export const PriceCol = styled(Col)`
  align-items: flex-end;
  display: inline-flex;
  flex-direction: row;
  gap: 1.5rem;
`

export const StyledRelatedSoles = styled(SimpleRelatedSoles)`
  flex-wrap: wrap;
  margin: 0 0 2rem;
`

export const StyledPairWith = styled(PairWith)`
  a {
    text-decoration: none;
  }
`
